'use client'

import { useAtomValue } from 'jotai/react'

import { useBasket } from '@/providers/basket-context'
import { selectedPetsAtom } from '@/states/selectionAtom'

import ContinueHandler from '../summary/ContinueHandler'
import { TotalPriceBlock } from '../summary/TotalPriceBlock'
import { StepType } from './steps'
import { SummaryContentDesktopSkeleton } from './summary/skeletons/SummaryContentDekstopSkeleton'
import { SummaryContentDesktop } from './summary/SummaryContentDekstop'
import { getSteps } from './summary/SummaryUtils'

interface Props {
  step: StepType
}

export const DesktopStepper = ({ step }: Props) => {
  const { basket, residentSwitchLoading } = useBasket()
  const { showNumberOfPets } = useAtomValue(selectedPetsAtom)
  const steps = getSteps(showNumberOfPets)
  const currentStep = steps.find((s) => s.stepType === step)
  const currentIndex = steps.findIndex((s) => s.stepType === step)

  // Show skeleton when the basket is undefined, or while a resident-vehicle toggle rebuilds it.
  if (!basket || residentSwitchLoading) {
    return <SummaryContentDesktopSkeleton />
  }

  return (
    <section className="bg-semantic-global-background-white flex h-full flex-col" data-e2e="desktop-stepper">
      {currentStep ? (
        <>
          <SummaryContentDesktop basket={basket} currentIndex={currentIndex} steps={steps} />
          <section className="p-semantic-global-md pb-semantic-global-md border-semantic-global-border-light w-full border-t bg-white">
            <div className="gap-semantic-global-md flex flex-col">
              <TotalPriceBlock />
              <ContinueHandler type="Desktop" />
            </div>
          </section>
        </>
      ) : null}
    </section>
  )
}
